var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopyIcon = function SvgCopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copy-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.416 1.76h5.445C10.042 1.76 11 2.719 11 3.9v5.444a2.14 2.14 0 0 1-2.14 2.139H3.417a2.14 2.14 0 0 1-2.139-2.139V3.9c0-1.182.958-2.14 2.14-2.14m8.21 3.2a.585.585 0 0 1 .76-.322 2.13 2.13 0 0 1 1.336 1.984v5.444c0 1.179-.96 2.138-2.14 2.138H6.139a2.13 2.13 0 0 1-1.983-1.336.584.584 0 0 1 1.082-.438c.15.37.503.609.901.609h5.446a.974.974 0 0 0 .972-.973V6.622a.97.97 0 0 0-.608-.902.584.584 0 0 1-.322-.76",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.983h14v14H.5z"
  })))));
};
export default SvgCopyIcon;